
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandQ as ObiOwnShipNoCommandQElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-q.js';
 
 
 

 
 export const ObiOwnShipNoCommandQ = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-q',
   elementClass: ObiOwnShipNoCommandQElement,
   events: {
     
   }
  });
 
 